(function() {
  if (window.__supportRenovationGsapBooted || typeof window.gsap === 'undefined') {
    return;
  }

  window.__supportRenovationGsapBooted = true;

  gsap.defaults({
    ease: (window.Power4 && Power4.easeOut) || 'power4.out'
  });

  gsap.config({
    nullTargetWarn: false
  });

  if (typeof gsap.registerPlugin === 'function') {
    var plugins = [window.ScrollTrigger, window.DrawSVGPlugin, window.SplitText].filter(Boolean);

    if (plugins.length) {
      gsap.registerPlugin.apply(gsap, plugins);
    }
  }
})();
